import { Link, useRemember } from "@inertiajs/react";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Drawer from '@mui/material/Drawer';
import React, { memo, useCallback, useEffect, useLayoutEffect, useState } from "react";
import Draggable from 'react-draggable';
import Box from "../../Components/Box";
import FlexBox from "../../Components/FlexBox";
import Image from "../../Components/Image";
import Typography, { H1, H3, Span } from "../../Components/Typography";
import IconButton from "../../Components/buttons/IconButton";
import Grid from "../../Components/grid/Grid";
import closeIcon from '../../Components/header/closeIcon.svg';
import Hidden from "../../Components/hidden/Hidden";
import Icon from "../../Components/icon/Icon";
import AppLayout from "../../Components/layout/AppLayout";
import Navbar from "../../Components/navbar/Navbar";
import CategoryPageProductsGrid from "../../Components/products/CategoryPageProductsGrid";
import CategoryPageProductsList from "../../Components/products/CategoryPageProductsList";
import ProductFilterCard from "../../Components/products/ProductFilterCard";
import { useAppContext } from "../../contexts/app/AppContext";
import { CategoryPageProvider } from "../../contexts/app/CategoryPageContext";
import useWindowSize from "../../hooks/useWindowSize";
import StyledCategoryPage from './CategoryPageStyle';
import { router } from '@inertiajs/react'
import { AnimatePresence, motion } from "framer-motion";
import useSearchTermUrl from "../../hooks/useSearchTermUrl";
import { useTranslation } from "react-i18next";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import StyledDrawerBackButton from "./StyledDrawerBackButton";

router.on('before', () => {
  document.querySelector('footer')?.classList.add("hidden")

})

router.on('success', () => {
  document.querySelector('footer')?.classList.remove("hidden")

})

const styleSidenav = [{

  '.MuiDrawer-paper': {
    backgroundColor: 'rgba(35, 31, 32, 0.9)!important',
    backdropFilter: 'blur(8px)',
    overflow: 'initial',
    borderTopLeftRadius: 30,
    borderBottomLeftRadius: 30,
    width: '330px!important',
    zIndex: '990!important'

  },

}]

const ProductSearchResult = memo(function ProductSearchResult(props) {

  const { t } = useTranslation()
  const { total } = props

  /*useEffect(() => {
    console.log(total)
  }, [props])*/


  const [view, setView] = useRemember('grid', "grid");
  const [open, setOpen] = useState(false);
  const toggleSidenav = () => setOpen(!open);
  const width = useWindowSize();
  const isTablet = width < 1025;
  const { imgsLoaded, setImgsLoaded } = useAppContext()
  const [showPage, setShowPage] = useState(true)
  const TermInUrl = useSearchTermUrl('search')

  useEffect(() => {
    if (TermInUrl) {
      setImgsLoaded(true)
    }

  }, [TermInUrl])

  useEffect(() => {
    //console.log('scrollRestoration3 => ', history.scrollRestoration)
    //history.scrollRestoration = "manual";
    setShowPage(true)
  }, [])

  const toggleView = useCallback(
    (v) => () => {
      setView(v)
    },
    []
  )

  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {

    const handleScroll = () => {
      const sidenavElement = document.getElementById('sidenav')
      if (sidenavElement) {
        const rect = sidenavElement.getBoundingClientRect()
        const isOutOfView = rect.bottom < 0 || rect.top > window.innerHeight
        setIsSticky(isOutOfView)
      }
    }

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, [])


  const MuiHandle = () => (
    <>
      {imgsLoaded && <FlexBox onClick={toggleSidenav} id="sidenav" flexDirection="row" width="100%" justifyContent="center" alignItems="center">
        <Draggable handle="#sidenav" >
          <Box position={isSticky ? 'fixed' : 'relative'} top='90%' right={0} zIndex={2} >

            <IconButton p='0.25rem' display='flex' backgroundColor={isSticky && 'black'} size="small" textAlign="center" borderRadius={3}>
              <Icon color="white">options</Icon>
              {isSticky && <Typography>{t("filters.title")}</Typography>}
            </IconButton>

          </Box>
        </Draggable>
        <Span color="white" fontWeight="normal">
          {t("filters.title")}
        </Span>
      </FlexBox>}
    </>
  )

  return (
    <CategoryPageProvider data={props}>

      <AppLayout navbar={<Navbar />} seo={props.seo}>
        <AnimatePresence initial={false}>
          {showPage && <motion.div
            key="category-list"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}>
            <StyledCategoryPage width={'100%'} maxWidth={'100%'} my={width > 900 ? '12rem' : '6rem'} minHeight={width > 1025 ? '40vh' : '100hv'} scroll-region>

              {imgsLoaded && <FlexBox justifyContent={'center'} alignItems='center' flexDirection='column' mb='3rem' className="category-name" color='white'>
                <H1 textAlign='center' fontWeight={'bold'}>{props.categoryName}</H1>
                <Breadcrumbs separator={<ArrowForwardIosIcon fontSize="10px" sx={{ color: 'white' }} />} aria-label="breadcrumb">
                  {
                    props.breadcrumbs?.map((value, index) => {

                      /*if (index + 1 === props.breadcrumbs.length) {
                        return (
                          <Span>{value.title}</Span>
                        )
                      } else {
                        return ( <Span>{value.title}</Span>)
                      }*/

                      if (index + 1 === props.breadcrumbs.length) {
                        return (
                          <Span key={index}>{value.title}</Span>
                        )
                      } else {

                        return (
                          <Link key={index} href={value.slug}><Span>{value.title}</Span></Link>
                        )
                      }


                      //return(<Link href={value.url}>{value.title} &gt; </Link>   )    
                    })
                  }
                </Breadcrumbs>

                {/* {
              props.breadcrumbs.map((value, index) => {

                if (index + 1 === props.breadcrumbs.length) {
                  return (
                    <Span>{value.title}</Span>
                  )
                } else {
                  return ( <Span>{value.title}</Span>)
                }
                //return(<Link href={value.url}>{value.title} &gt; </Link>   )    
              })
            } */}
              </FlexBox>}

              <Box >
                {isTablet && (
                  <>
                    <MuiHandle />
                    <Drawer
                      anchor='right'
                      open={open}
                      sx={styleSidenav}
                      onClose={toggleSidenav}
                    >
                      <StyledDrawerBackButton onClick={toggleSidenav} className='close-button'>
                        <NavigateNextIcon fontSize="large" sx={{ color: 'white' }} />
                      </StyledDrawerBackButton>
                      
                      {/* <Image mt={24} mr={20} onClick={toggleSidenav} src={closeIcon}
                    style={{ position: 'absolute', cursor: 'pointer', right: 0 }} /> */}
                      <Box mt={'3rem'} p={20}>
                        <Box textAlign={'center'}>
                          <H3 fontWeight='bold' color='white'>{t("filters.title")}</H3>
                        </Box>
                        <ProductFilterCard toggleView={toggleView} filters={props.filterableAttributes} view={view} />
                      </Box>
                    </Drawer>
                  </>
                )}


                <Grid container spacing={0} >


                  {total > 0
                    ? <Hidden className='filter-wrapper' as={Grid} item lg={2.4} xs={12} down={1024} >
                      <ProductFilterCard toggleView={toggleView} filters={props.filterableAttributes} view={view} />
                    </Hidden>
                    : <></>}


                  <Grid item lg={total > 0 ? 9.5 : 12} xs={12} >
                    {view === "grid" || view === "grid3"
                      ? <CategoryPageProductsGrid setShowPage={setShowPage} view={view} />
                      : <CategoryPageProductsList />}
                  </Grid>

                </Grid>
              </Box>

            </StyledCategoryPage>
          </motion.div>}
        </AnimatePresence>
      </AppLayout >
    </CategoryPageProvider >
  )
})

const sortOptions = [
  { label: "Relevance", value: "Relevance" },
  { label: "Date", value: "Date" },
  { label: "Price Low to High", value: "Price Low to High" },
  { label: "Price High to Low", value: "Price High to Low" },
];

//ProductSearchResult.layout = NavbarLayout;

export default ProductSearchResult;
